export const TokenCache = {
  provider: "",
  token: "",
};
